'use strict';

var _typeof = require("@babel/runtime/helpers/typeof");

module.exports = function (x) {
  var type = _typeof(x);

  return x !== null && (type === 'object' || type === 'function');
};